<template>
  <el-dialog title="设备权限"
             :visible.sync="showArea"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-col :span="24">
      <el-form :model="authForm"
               :rules="authRules"
               ref="authForm"
               label-width="90px">
        <el-form-item label="角色名称"
                      prop="roleName">
          <el-input disabled
                    v-model="authForm.roleName"></el-input>
        </el-form-item>
        <el-form-item label="权限:"
                      prop="role_area">
          <el-tree class="auth-main"
                   ref="authorityTree"
                   :data="roleList"
                   show-checkbox
                   node-key="id"
                   :default-checked-keys="defaultKeys"
                   :props="defaultProps"
                   @check-change="checkChange">
          </el-tree>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/role/edit'"
                 type="primary"
                 @click="handleConfirm('authForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showArea: this.isShow,
      authForm: {
        roleName: '',
        role_area: []
      },
      authRules: {},
      roleList: [],
      defaultKeys: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  created() {
    this.authForm.roleName = this.data.role
    this.getList()
    this.getInfo()
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getRoleInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.defaultKeys = data.role_area ? data.role_area.split(',') : []
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取列表
    getList() {
      fetch.getAreaTreeManage({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roleList = data.treeData
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    checkChange() {
      this.authForm.role_area = this.$refs.authorityTree.getCheckedKeys()
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let half_area = this.$refs.authorityTree.getHalfCheckedKeys()
          this.authForm.role_area = this.$refs.authorityTree.getCheckedKeys()
          let datas = JSON.parse(JSON.stringify(this.authForm))
          datas.half_area = half_area.join(',')
          datas.role_area = datas.role_area.join(',')
          datas.id = this.data.id
          delete datas.roleName
          fetch.editRole({ ...datas }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.$emit('handleClose')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.$emit('handleClose')
    }
  }
}
</script>

<style lang="less" scoped>
.auth-main {
  max-height: 400px;
  overflow-y: auto;
}
</style>
